import React from 'react'
import './Footer.css'
import logo from '../Assets/logo.png'
import facebook from '../Assets/facebook.png'
import youtube from '../Assets/youtube.png'
import instagram from '../Assets/instagram.png'
import VisitCounter from "../VisitCounter/VisitCounter";


const Footer = () => {
  return (
    <div className='footer'>
        <div className="footer-log">
            <img src={logo} alt=''/>
        </div>
        {/* <ul className='footer-links'>
            <li>Company</li>
            <li>Products</li>
            <li>About</li>
            <li>Contact</li>
        </ul> */}
        <div className="footer-social-icon">
            <div className="footer-icon-container">
                <a href="https://www.youtube.com/@kanhawondercraft" target='blank'><img src={youtube} alt='Youtube'/></a>
            </div>
            <div className="footer-icon-container">
                <a href='https://www.facebook.com/kanha.wondercraft' target='blank'><img src={facebook} alt='Facebook'/></a>
            </div>
            <div className="footer-icon-container">
                <a href='https://www.instagram.com/kanhawondercraft' target='blank'><img src={instagram} alt='Instagram'/></a>
            </div>
        </div>

        <VisitCounter />

        <div className="footer-copyright">
            <hr />
            <p>Copyright @ {new Date().getFullYear()} - All Right Reserved</p>
        </div>
    </div>
  )
}

export default Footer